type DateParts = {
  date: string;
  time: string;
  iso: string;
};

function parseDateParts(value?: string | null): DateParts | null {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;

  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");

  return {
    date: `${y}-${m}-${day}`,
    time: `${h}:${min}`,
    iso: d.toISOString(),
  };
}

/** 表格时间单元格：日期/时间分层 + tabular-nums，避免一行大字挤在一起。 */
export function DataTableDateTime({ value }: { value?: string | null }) {
  const parts = parseDateParts(value);
  if (!parts) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  return (
    <time
      dateTime={parts.iso}
      title={`${parts.date} ${parts.time}`}
      className="flex flex-col gap-0.5 leading-tight tabular-nums"
    >
      <span className="text-xs text-foreground/90">{parts.date}</span>
      <span className="text-[11px] text-muted-foreground">{parts.time}</span>
    </time>
  );
}
